import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MapPin, X, ArrowRight } from "lucide-react";
import { fetchGeo, touristContext } from "../lib/geoContext";

// País del visitante → destino eSIM de LiveWifi Travel
const COUNTRY_TO_DEST = {
  GB: "reino-unido", MA: "marruecos", TH: "tailandia", MX: "mexico", AR: "argentina", DO: "republica-dominicana",
  CU: "cuba", EG: "egipto", AE: "dubai", CN: "china", VN: "vietnam", BR: "brasil", CO: "colombia", PE: "peru",
  CA: "canada", AU: "australia", IT: "italia", FR: "francia", PT: "portugal", CH: "suiza", TR: "turquia", US: "usa", JP: "japon",
};
const EU = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "DE", "GR", "HU", "IE", "LV", "LT", "LU", "MT", "NL", "PL", "RO", "SK", "SI", "SE", "NO", "IS"];
const KEY = "lw_geo_chip_dismissed";

// Sugerencia discreta según la zona del visitante. No cambia nada por sí sola: solo ofrece la opción de su país/zona.
export const GeoSuggestChip = () => {
  const [geo, setGeo] = useState(null);
  const [hidden, setHidden] = useState(() => { try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; } });
  const [cookiesAnswered, setCookiesAnswered] = useState(() => { try { return !!localStorage.getItem("livewifi_cookie_consent"); } catch { return true; } });
  const { pathname } = useLocation();

  // Esperar a que el usuario responda al aviso de cookies para no solapar dos avisos
  useEffect(() => {
    if (cookiesAnswered) return;
    const t = setInterval(() => { try { if (localStorage.getItem("livewifi_cookie_consent")) setCookiesAnswered(true); } catch {} }, 1000);
    return () => clearInterval(t);
  }, [cookiesAnswered]);

  useEffect(() => {
    if (hidden) return;
    fetchGeo().then((g) => setGeo(g));
  }, [hidden]);

  // Si aplica el banner de viajero (aeropuerto / extranjero / idioma), no mostramos también el chip
  if (hidden || !cookiesAnswered || !geo?.ok || geo.is_canarias || touristContext(geo)) return null;

  const shortCountry = (c = "") => (c.length > 22 ? c.split(/ de | \(/)[0] : c);
  let text, to, cta;
  if (geo.is_spain) {
    if (pathname.startsWith("/peninsula")) return null;
    text = `Estás en ${geo.region || "Península"}`;
    to = "/peninsula"; cta = "Ver tarifas Península";
  } else {
    const slug = COUNTRY_TO_DEST[geo.country_code] || (EU.includes(geo.country_code) ? "europa" : "mundo");
    if (pathname.startsWith("/travel")) return null;
    const c = shortCountry(geo.country) || "tu país";
    text = `Estás en ${c}`;
    to = `/travel/${slug}`; cta = `Ver eSIM para ${c}`;
  }

  const dismiss = () => { try { sessionStorage.setItem(KEY, "1"); } catch {} setHidden(true); };

  return (
    <div className="fixed bottom-4 left-4 z-[60] max-w-[calc(100vw-2rem)] animate-in fade-in slide-in-from-bottom-2" data-testid="geo-suggest-chip">
      <div className="flex items-center gap-3 pl-3 pr-2 py-2 rounded-full bg-[#141414]/95 backdrop-blur border border-white/10 shadow-xl">
        <MapPin className="w-4 h-4 text-[#7DD500] shrink-0" />
        <span className="text-white/60 text-xs hidden sm:inline">{text} ·</span>
        <Link to={to} onClick={dismiss} data-testid="geo-suggest-link" className="text-[#7DD500] text-xs font-bold hover:underline inline-flex items-center gap-1 whitespace-nowrap">
          {cta} <ArrowRight className="w-3 h-3" />
        </Link>
        <button onClick={dismiss} aria-label="Cerrar" data-testid="geo-suggest-close" className="p-1 rounded-full text-white/40 hover:text-white hover:bg-white/10">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
